export function isCategory(count) {
  return count >= 2 && count <= 50
}
